export default __webpack_public_path__ + "static/media/yd-about.b499d4cc.png";